
// Tooltip — themed card style (matches current mode, not always dark)
export const root = {
    maxWidth: '12.5rem',
    gutter: '0.25rem',
    shadow: '0 4px 16px rgba(0, 0, 0, 0.3)',
    padding: '0.375rem 0.75rem',
    borderRadius: '{border.radius.lg}'
};

export const colorScheme = {
    light: {
        root: {
            background: '{surface.card}',
            color: '{text.color}'
        }
    },
    dark: {
        root: {
            background: '{surface.card}',
            color: '{text.color}'
        }
    }
};

export default {
    root,
    colorScheme
};
